<script lang="ts">
  import { abTestVersion } from '$lib/stores/ab-test-version';
  import { cn } from '$lib/utils';
  import type { AbTestContentStoryblok, ProductAsVariantStoryblok } from '$types/bloks';
  import ProductsAsVariant from './products-as-variant.svelte';
  import ShopifyVariants from './shopify-variants.svelte';
  import { onMount, type ComponentProps } from 'svelte';

  export let product: ComponentProps<ShopifyVariants>['product'];
  export let isPreSale: boolean;
  export let variantsAsProducts: (ProductAsVariantStoryblok | AbTestContentStoryblok)[] | undefined;
  let productVariantBlocks: ProductAsVariantStoryblok[];
  export let wontBeRestocked: ComponentProps<ShopifyVariants>['wontBeRestocked'];
  export let selectedOptions: ComponentProps<ShopifyVariants>['selectedOptions'];
  export let sizeGuideOnClick: (() => void) | undefined = undefined;

  const options = product.options;
  $: hasOnlyDefaultVariant = options?.length === 1 && options[0].values.length === 1;

  const getProductVariantBlocks = (abTestVersionValue: string | undefined) => {
    if (!variantsAsProducts) return [];

    return variantsAsProducts.flatMap((variantBlock) => {
      if (variantBlock.component === 'ab-test-content') {
        if (variantBlock.version === abTestVersionValue && variantBlock.body) {
          return variantBlock.body as ProductAsVariantStoryblok[];
        }
        return [];
      }

      return [variantBlock];
    });
  };

  onMount(() => {
    const unsubscribe = abTestVersion.subscribe((currentVersion) => {
      productVariantBlocks = getProductVariantBlocks(currentVersion);
    });

    // Cleanup on component destroy
    return () => unsubscribe();
  });
</script>

{#if !hasOnlyDefaultVariant || !!productVariantBlocks?.length}
  <div class={cn('flex flex-col gap-6', hasOnlyDefaultVariant ? 'mb-11' : 'mb-4')}>
    <ProductsAsVariant blocks={productVariantBlocks} />
    <ShopifyVariants
      {product}
      bind:selectedOptions
      {wontBeRestocked}
      {isPreSale}
      {sizeGuideOnClick}
    />
  </div>
{/if}
